import { defineStore } from "pinia";

const useCustomerAssignmentStore = defineStore("customerAssignmentStore", {
  state: () => ({
    fTM: true,
    fAdvisor: true,
    fSupport: true,
  }),

  actions: {
    setFTM(value) {
      this.fTM = value;
    },
    setFAdvisor(value) {
      this.fAdvisor = value;
    },
    setFSupport(value) {
      this.fSupport = value;
    }
  },
});

export default useCustomerAssignmentStore;